import { useSyncExternalStore } from 'react';

export type ColorScheme = 'light' | 'dark';

// The resolved scheme (system already applied), kept outside React so GoJS
// templates and Chart.js plugins can read it. `AppThemeProvider` keeps it in
// sync with MUI's colour scheme.
let currentScheme: ColorScheme = 'light';
const listeners = new Set<() => void>();

export const getColorScheme = () => currentScheme;

export const setColorScheme = (scheme: ColorScheme) => {
  if (scheme === currentScheme) {
    return;
  }
  currentScheme = scheme;
  listeners.forEach((listener) => listener());
};

export const subscribeToColorScheme = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useResolvedColorScheme = () =>
  useSyncExternalStore(subscribeToColorScheme, getColorScheme);
